import { addLayerStatus as apiAddLayerStatus,
  editLayerStatus as apiEditLayerStatus,
  linkLayerStatus as apiLinkLayerStatus,
  deleteLayerStatus as apiDeleteLayerStatus,
  fetchPictogramLayerStatuses as apiFetchPictogramLayerStatuses } from '../api/layer-statuses.api.js';

import { apiCall } from '../helpers/api.helper.js';

export async function addLayerStatus(layerId, payload) {
  return apiCall(apiAddLayerStatus, layerId, payload);
}

export async function editLayerStatus(layerId, statusId, payload) {
  return apiCall(apiEditLayerStatus, layerId, statusId, payload);
}

export async function linkLayerStatus(layerId, statusId, payload) {
  return apiCall(apiLinkLayerStatus, layerId, statusId, payload);
}

export async function deleteLayerStatus(layerId, statusId) {
  return apiCall(apiDeleteLayerStatus, layerId, statusId);
}

export async function getPictogramLayerStatuses(layerId, params = {}) {
  return apiCall(apiFetchPictogramLayerStatuses, layerId, params);
}
